import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import moment from "moment";
import { route } from "../routes";
import {
  GelContentContainer,
  GelContentRow,
  GelContentColumn,
  Highlight,
  TopNavigation,
  ShowMoreLess,
  Button,
  Notice,
  Link,
  Sanitize,
} from "cw-styleguide-react";
import { APPLICATION_FORMAT_EMAIL, APPLICATION_FORMAT_URL } from "../constants";
import { Helmet } from "react-helmet";

class DetailView extends Component {
  generateJumpList() {
    return [
      this.props.aboutDuties || this.props.aboutAdditionalInformation
        ? { url: "#about", text: this.props.t("view.detail.subheadings.about") }
        : null,
      this.props.requirementsQualifications || this.props.requirementsSkills
        ? {
            url: "#requirements",
            text: this.props.t("view.detail.subheadings.requirements"),
          }
        : null,
      this.props.trainingProvider || this.props.trainingQualification
        ? {
            url: "#training",
            text: this.props.t("view.detail.subheadings.training"),
          }
        : null,
      {
        url: "#disability",
        text: this.props.t("view.detail.subheadings.disability"),
      },
      this.props.employerName || this.props.employerMap
        ? {
            url: "#employer",
            text: this.props.t("view.detail.subheadings.employer"),
          }
        : null,
      this.props.interview
        ? {
            url: "#interview",
            text: this.props.t("view.detail.subheadings.interview"),
          }
        : null,
      this.props.applicationUrl || this.props.applicationEmail
        ? {
            url: "#application",
            text: this.props.t("view.detail.subheadings.application"),
          }
        : null,
    ]
      .filter((item) => item)
      .map((item, index) => ({ ...item, text: `${index + 1}. ${item.text}` }));
  }

  render() {
    return (
      <Fragment>
        <Helmet>
          <title>
            {this.props.title} | {this.props.t("app.name")}
          </title>
        </Helmet>
        <BreadcrumbsItem to={route("results") + this.props.query}>
          {this.props.t("breadcrumbs.results")}
        </BreadcrumbsItem>
        <BreadcrumbsItem
          to={
            route("detail", { apprenticeship: this.props.slug }) +
            this.props.query
          }
        >
          {this.props.title}
        </BreadcrumbsItem>
        <GelContentContainer>
          <h1>{this.props.title}</h1>
          {this.props.status === "archived" && (
            <Notice type={"info-icon"}>
              <span>
                {this.props.t("misc.closed")}{" "}
                <Link to={route("apprenticeshipSearch")}>
                  {this.props.t("breadcrumbs.apprenticeshipSearch")}
                </Link>
                .
              </span>
            </Notice>
          )}
          <Highlight bordered={true}>
            <GelContentRow>
              <GelContentColumn xs={3}>
                <p>
                  <strong>{this.props.t("view.detail.labels.employer")}</strong>
                </p>
              </GelContentColumn>
              <GelContentColumn xs={9}>
                <p>{this.props.employerName}</p>
              </GelContentColumn>
            </GelContentRow>
            <GelContentRow>
              <GelContentColumn xs={3}>
                <p>
                  <strong>{this.props.t("view.detail.labels.location")}</strong>
                </p>
              </GelContentColumn>
              <GelContentColumn xs={9}>
                <p>{this.props.employerLocality}</p>
              </GelContentColumn>
            </GelContentRow>
            <GelContentRow>
              <GelContentColumn xs={3}>
                <p>
                  <strong>{this.props.t("view.detail.labels.level")}</strong>
                </p>
              </GelContentColumn>
              <GelContentColumn xs={9}>
                <p>{this.props.level}</p>
              </GelContentColumn>
            </GelContentRow>
            <GelContentRow>
              <GelContentColumn xs={3}>
                <p>
                  <strong>{this.props.t("view.detail.labels.pay")}</strong>
                </p>
              </GelContentColumn>
              <GelContentColumn xs={9}>
                <p>{this.props.pay}</p>
              </GelContentColumn>
            </GelContentRow>
            <GelContentRow>
              <GelContentColumn xs={3}>
                <p>
                  <strong>{this.props.t("view.detail.labels.hours")}</strong>
                </p>
              </GelContentColumn>
              <GelContentColumn xs={9}>
                <p>{this.props.hours}</p>
              </GelContentColumn>
            </GelContentRow>
            <GelContentRow>
              <GelContentColumn xs={3}>
                <p>
                  <strong>{this.props.t("view.detail.labels.closing")}</strong>
                </p>
              </GelContentColumn>
              <GelContentColumn xs={9}>
                <p>{moment(this.props.closing).format("DD/MM/YYYY")}</p>
              </GelContentColumn>
            </GelContentRow>
            <GelContentRow>
              <GelContentColumn xs={3}>
                <p>
                  <strong>
                    {this.props.t("view.detail.labels.positions")}
                  </strong>
                </p>
              </GelContentColumn>
              <GelContentColumn xs={9}>
                <p>{this.props.positions}</p>
              </GelContentColumn>
            </GelContentRow>
            <GelContentRow>
              <GelContentColumn xs={3}>
                <p>
                  <strong>{this.props.t("view.detail.labels.id")}</strong>
                </p>
              </GelContentColumn>
              <GelContentColumn xs={9}>
                <p>{this.props.id}</p>
              </GelContentColumn>
            </GelContentRow>
            {this.props.applicationFormat === APPLICATION_FORMAT_EMAIL && (
              <GelContentRow>
                <GelContentColumn xs={3}>
                  <p>
                    <strong>
                      {this.props.t("view.detail.labels.application")}
                    </strong>
                  </p>
                </GelContentColumn>
                <GelContentColumn xs={9}>
                  <p>{this.props.t("misc.emailPrompt")}</p>
                  <p>
                    <a href={"mailto:" + this.props.applicationEmail}>
                      {this.props.applicationEmail}
                    </a>
                  </p>
                  {this.props.applicationInstructions && (
                    <p>
                      <Sanitize
                        html={this.props.applicationInstructions}
                      />
                    </p>
                  )}
                </GelContentColumn>
              </GelContentRow>
            )}
            {this.props.applicationFormat === APPLICATION_FORMAT_URL && (
              <Fragment>
                <br />
                <a
                  href={this.props.applicationUrl}
                  target={"_blank"}
                  title={this.props.t("misc.linkToEmployer")}
                  className={
                    "button button--icon icon--external-link icon--right"
                  }
                >
                  {this.props.t("misc.applyNow")}
                </a>
                <p>{this.props.t("misc.externalLink")}</p>
              </Fragment>
            )}
          </Highlight>
          <TopNavigation
            title={this.props.t("misc.contents")}
            links={this.generateJumpList()}
          />
          {/* About */}
          {(this.props.aboutDuties ||
            this.props.aboutAdditionalInformation) && (
            <Fragment>
              <div className="gel-xs-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
                <h2 id={"about"}>
                  {this.props.t("view.detail.subheadings.about")}
                </h2>
                {/* About duties */}
                {this.props.aboutDuties && (
                  <Fragment>
                    <h3>{this.props.t("view.detail.subheadings.duties")}</h3>
                    <Sanitize html={this.props.aboutDuties} />
                  </Fragment>
                )}
                {/* About additional information */}
                {this.props.aboutAdditionalInformation && (
                  <Fragment>
                    <h3>
                      {this.props.t(
                        "view.detail.subheadings.additionalInformation"
                      )}
                    </h3>
                    <Sanitize html={this.props.aboutAdditionalInformation} />
                  </Fragment>
                )}
              </div>
            </Fragment>
          )}
          {/* Requirements */}
          {(this.props.requirementsQualifications ||
            this.props.requirementsSkills) && (
            <Fragment>
              <div className="gel-xs-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
                <h2 id={"requirements"}>
                  {this.props.t("view.detail.subheadings.requirements")}
                </h2>
                {/* Requirements qualifications */}
                {(this.props.requirementsRequiredQualifications ||
                  this.props.requirementsDesirableQualifications) && (
                  <Fragment>
                    <h3>
                      {this.props.t("view.detail.subheadings.qualifications")}
                    </h3>
                    <Sanitize
                      html={this.props.requirementsRequiredQualifications}
                    />
                    <Sanitize
                      html={this.props.requirementsDesirableQualifications}
                    />
                  </Fragment>
                )}
                {/* Requirements skills */}
                {this.props.requirementsSkills && (
                  <Fragment>
                    <h3>{this.props.t("view.detail.subheadings.skills")}</h3>
                    <Sanitize html={this.props.requirementsSkills} />
                  </Fragment>
                )}
                {/* Requirements welsh */}
                <h3>{this.props.t("view.detail.subheadings.welsh")}</h3>
                <p>
                  <strong>
                    {this.props.t("view.detail.labels.welshSpoken")}:
                  </strong>{" "}
                  {this.props.requirementsWelshSpoken
                    ? this.props.t("misc.yes")
                    : this.props.t("misc.no")}
                </p>
                <p>
                  <strong>
                    {this.props.t("view.detail.labels.welshWritten")}:
                  </strong>{" "}
                  {this.props.requirementsWelshWritten
                    ? this.props.t("misc.yes")
                    : this.props.t("misc.no")}
                </p>
                <p>{this.props.t("misc.welshPrompt")}</p>
              </div>
            </Fragment>
          )}
          {/* Training */}
          {(this.props.trainingQualification ||
            this.props.trainingProvider) && (
            <Fragment>
              <div className="gel-xs-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
                <h2 id={"training"}>
                  {this.props.t("view.detail.subheadings.training")}
                </h2>
                {/* Training provider */}
                {this.props.trainingProvider && (
                  <Fragment>
                    <h3>{this.props.t("view.detail.subheadings.provider")}</h3>
                    <Sanitize html={this.props.trainingProvider} />
                  </Fragment>
                )}
                {/* Training qualification */}
                {this.props.trainingQualification && (
                  <Fragment>
                    <h3>
                      {this.props.t("view.detail.subheadings.qualification")}
                    </h3>
                    <Sanitize html={this.props.trainingQualification} />
                  </Fragment>
                )}
              </div>
            </Fragment>
          )}
          {/* Disability confident */}
          <div className="gel-xs-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
            <h2 id={"disability"}>
              {this.props.t("view.detail.subheadings.disability")}
            </h2>
            <p className="gel-xs-mb-30">
              <strong>
                {this.props.t("view.detail.subheadings.confident")}:
              </strong>{" "}
              {this.props.disabilityConfident
                ? this.props.t("misc.yes")
                : this.props.t("misc.no")}
            </p>
            <div>
              <ShowMoreLess
                moreText={this.props.t("filters.disability.help.label")}
                lessText={this.props.t("filters.disability.help.label")}
                flipped={true}
              >
                <p>{this.props.t("filters.disability.help.text")}</p>
              </ShowMoreLess>
            </div>
          </div>
          {/* Employer */}
          {(this.props.employerName || this.props.employerMap) && (
            <Fragment>
              <div className="gel-xs-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
                <h2 id={"employer"}>
                  {this.props.t("view.detail.subheadings.employer")}
                </h2>
                {/* Employer name */}
                {this.props.employerName && <h3>{this.props.employerName}</h3>}
                <p>
                  {/* Employer address 1 */}
                  {this.props.employerAddressLine1 && (
                    <Fragment>
                      <span>{this.props.employerAddressLine1}</span>
                      <br />
                    </Fragment>
                  )}
                  {/* Employer address 2 */}
                  {this.props.employerAddressLine2 && (
                    <Fragment>
                      <span>{this.props.employerAddressLine2}</span>
                      <br />
                    </Fragment>
                  )}
                  {/* Employer locality */}
                  {this.props.employerLocality && (
                    <Fragment>
                      <span>{this.props.employerLocality}</span>
                      <br />
                    </Fragment>
                  )}
                  {/* Employer country code */}
                  {this.props.employerCountryCode && (
                    <Fragment>
                      <span>{this.props.employerCountryCode}</span>
                      <br />
                    </Fragment>
                  )}
                  {/* Employer postal code */}
                  {this.props.employerPostalCode && (
                    <Fragment>
                      <span>{this.props.employerPostalCode}</span>
                      <br />
                    </Fragment>
                  )}
                </p>
                {/* Employer map */}
                {this.props.employerMap && (
                  <p>
                    <Link
                      className="style--icon-pin"
                      to={this.props.employerMap}
                      target={"_blank"}
                    >
                      {this.props.t("view.detail.labels.map")}
                    </Link>
                  </p>
                )}
              </div>
            </Fragment>
          )}
          {/* Interview */}
          {this.props.interview && (
            <Fragment>
              <div className="gel-xs-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
                <h2 id={"interview"}>
                  {this.props.t("view.detail.subheadings.interview")}
                </h2>
                <Sanitize html={this.props.interview} />
              </div>
            </Fragment>
          )}
          {/* Application */}
          {(this.props.applicationUrl || this.props.applicationEmail) && (
            <Fragment>
              <div className="gel-xs-mb-40 gel-sm-mb-40 gel-md-mb-40 gel-lg-mb-40 gel-xl-mb-40">
                <h2 id={"application"}>
                  {this.props.t("view.detail.subheadings.application")}
                </h2>
                {/* Application url */}
                {this.props.applicationFormat === APPLICATION_FORMAT_URL && (
                  <Fragment>
                    <p>{this.props.t("misc.applyForVacancyUrl")}</p>
                    <a
                      href={this.props.applicationUrl}
                      target={"_blank"}
                      title={this.props.t("misc.linkToEmployer")}
                      className={
                        "button button--icon icon--external-link icon--right"
                      }
                    >
                      {this.props.t("misc.applyNow")}
                    </a>
                  </Fragment>
                )}
                {/* Application email */}
                {this.props.applicationFormat === APPLICATION_FORMAT_EMAIL && (
                  <Fragment>
                    <p>{this.props.t("misc.emailPrompt")}</p>
                    <p>
                      <a href={"mailto:" + this.props.applicationEmail}>
                        {this.props.applicationEmail}
                      </a>
                    </p>{" "}
                    {this.props.applicationInstructions && (
                      <p>{this.props.applicationInstructions}</p>
                    )}
                  </Fragment>
                )}
              </div>
            </Fragment>
          )}
          <div className="gel-xs-mb-50 gel-sm-mb-50 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50">
            <Notice type={"info-icon"}>
              <span>{this.props.t("view.detail.notice")}</span>
            </Notice>
          </div>
          <Button
            url={route("results") + this.props.query}
            theme={["style-dark"]}
            icon={{ type: "chevron-left", position: "left" }}
          >
            {this.props.t("misc.backToResults")}
          </Button>
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withTranslation("local")(DetailView);
